require('babel-polyfill')
const gc = require("../config/gc");
require('dotenv').config()

const bucket = gc.bucket(process.env.GOOGLEBUCKET_KEY || "billbook_stage");

const uploadFile = async (filePath, destFileName) => {
    return new Promise((resolve,reject) => {
        bucket.upload(filePath, {
            destination: destFileName,
        }, (err, file) => {
            if (err) {
                reject(err)
            }
            resolve("https://storage.googleapis.com/"+ bucket.name + "/" + destFileName);
        });
    }) 
}

module.exports = uploadFile
